import { Key, useState } from "react";
import { createModel } from "hox";
import { useSessionStorageState } from "ahooks";
import { IAccountSummaryShop, IAllotAccountDetail, IAllotSummaryAmount, ICustomerAccountSummary } from "../AccountTypes";
import { accountService, IAcctUnitDetail } from "../AccountService";
import useNavModel from "@/model/navModel";
import { IMdOrgDetail, orgService } from "../../base/org/orgService";
import { ITreeData } from "../../base/dict/dictModel";
import { OptionDsType } from "@/types/FmsTypes";
import { useGlobalModel } from "@/model/globalModel";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { IMdDictFields } from "@/views/base/dict/dictService";

export enum ActionTypeEnum {
    ACCOUNT,       // 账户管理
    WRITEOFF,      // 核销单
    RECHARGE_LIST, // 充值记录
    TRANSFER_LIst, // 转账记录
    BILL_LIST,     // 账单信息
    WRITEOFF_LIST, // 核销记录
    LOG_LIST,      // 操作日志
    TRANSACTION,   // 交易往来
    NULL
}

type labelsType = {
    [proppName: string]: string;
}

export const useDetailModel = createModel(function () {
    const { user: { shopCode } } = useGlobalModel();
    const [customerCode, setCustomerCode] = useSessionStorageState<string>("accountShop.detail.customerCode", "");
    const [actionType, setActionType] = useSessionStorageState<ActionTypeEnum>("customerManage.detail.type", ActionTypeEnum.NULL) // 选中展示模块
    const [customer, setCustomer] = useState<ICustomerAccountSummary>({ key: "" });
    const { closeNav } = useNavModel(() => []);

    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
    const [beDs, setBeDs] = useState<OptionDsType[]>();
    const [appDs, setAppDs] = useState<OptionDsType[]>();
    // const [unit, setUnit] = useState<IAcctUnitDetail>();
    const [payMethodLabels, setPayMethodLabels] = useState<labelsType>({});
    const [payMethodDs, setPayMethodDs] = useState<ITreeData<IMdDictFields>[]>();
    const [accountTypeDs, setAccountType] = useState<OptionDsType[]>([]);
    const [accountSummary, setAccountSummary] = useState<IAllotSummaryAmount>({
        totalUsedAmount: 0,
        totalCreditAmount: 0,
        totalRemainingAmount: 0,
        totalDebtAmount:0,
        totalAvailableAmount: 0
    })
    const [customerUserDs, setCustomerUserDs] = useState<OptionDsType[]>(); // 选中客户下的账户列表
    const [customerUserList, setCustomerUserList] = useState<IAllotAccountDetail[]>(); // 选中客户下的账户列表

    const loadSummaryData = () => {
        accountService
            .allotSelectSummaryAmount(shopCode)
            .then(({ retData }) => {
                setAccountSummary(retData)
                // setCustomer(retData ?? {});
            });
    }

    const loadCustomer = async () => {
        const {retData} = await accountService.allotPage({page: {pageNum:1, pageSize:9999}})
        setCustomerUserList(retData.records)
        setCustomerUserDs(
            retData.records.map(item => (
                {
                    label: item.name ?? '',
                    value: item.code ?? '',
                    unitCode: item.unitCode ?? ''
                }
            ))
        )
    }

    return {
        appDs,
        orgDs,
        beDs,
        payMethodDs,
        payMethodLabels,
        actionType,
        customerCode,
        customer,
        accountSummary,
        customerUserDs,
        customerUserList,
        // unit,
        accountTypeDs, setAccountType,
        setActionType,
        setCustomerCode,
        loadSummaryData,
        setOrgDs,
        setBeDs,
        setPayMethodDs,
        setPayMethodLabels,
        setAppDs,
        closeNav,
        setCustomerUserList,
        setCustomerUserDs,
        loadCustomer,
        // setUnit,
    }
});
